/**
 * Checks if the current pathname is the home page.
 * @param pathname - The current URL pathname.
 * @returns True if the pathname is '/', false otherwise.
 */
export const isHomePage = (pathname: string): boolean => {
  return pathname === "/";
};
